import {
  MdOutlinePower,
  MdFormatListBulleted,
  MdNotifications,
  MdAccountCircle,
  MdBusiness,
  MdSettings,
  MdOutlineLocalShipping,
  MdOutlineEventNote,
} from 'react-icons/md'
import account from '@src/assets/icons/account.svg'
import mail from '@src/assets/icons/mail.svg'
import bookings from '@src/assets/icons/bookings.svg'

export const ourServicesMenuItems = [
  {
    label: "Regulated Waste Disposal",
    link: "/regulated-waste-disposal",
    column: 1,
    subLinks: [
      {
        label: "Oil Container Pickup",
        link: "/oil-recycling",
      },
      {
        label: "Oil Pumping Service",
        link: "/oil-recycling",
      },
      {
        label: "Paint Recycling and Disposal",
        link: "/paint-disposal",
      },
      {
        label: "Other Regulated Waste Disposal",
        link: "/regulated-waste-disposal",
      },
    ],
  },
  {
    label: "Hazardous Waste Services",
    link: "/hazardous-waste-disposal",
    column: 1,
    subLinks: [
      {
        label: "Flammable Waste Disposal",
        link: "/flammable-waste-disposal",
      },
      {
        label: "Corrosive Waste Disposal",
        link: "/corrosive-waste-disposal",
      },
      {
        label: "Toxic Waste Disposal",
        link: "/toxic-waste-disposal",
      },
      {
        label: "Labpack Services",
        link: "/lab-pack-services",
      },
      {
        label: "Medical Waste Disposal",
        link: "/medical-waste-disposal",
      },
      {
        label: "Sharps Disposal",
        link: "/sharps-disposal",
      },
      {
        label: 'Fire Debris Removal',
        link: '/fire-debris-removal',
      },
      {
        label: "Other Hazardous Waste",
        link: "/other-hazardous-waste",
      },
    ],
  },
  {
    label: 'Sanitizer and PPE Recycling',
    link: '/hand-sanitizer-disposal',
    column: 1,
    subLinks: [
      {
        label: 'Hand Sanitizer Disposal',
        link: '/hand-sanitizer-disposal',
      },
      {
        label: 'Hand Sanitizer Recycling',
        link: '/hand-sanitizer-recycling',
      },
      {
        label: 'PPE Disposal and Recycling',
        link: '/ppe-disposal',
      },
    ],
  },
  {
    label: 'Beverage and Alcohol Disposal',
    link: '/beverage-disposal',
    column: 1,
    subLinks: [
      {
        label: 'Alcoholic Beverages',
        link: '/alcoholic-beverage-disposal',
      },
      {
        label: 'Sugary Beverages',
        link: '/sugary-beverage-disposal',
      },
      {
        label: 'Milk Beverages and Dairy',
        link: '/milk-dairy-disposal',
      },
      {
        label: 'Industrial Alcohol',
        link: '/industrial-alcohol-disposal',
      },
    ],
  },
  {
    label: 'Junk Removal Services',
    link: '/junk-removal',
    column: 2,
    subLinks: [
      {
        label: 'Mattress Removal',
        link: '/mattress-removal',
      },
      {
        label: 'Appliance Removal',
        link: '/appliance-removal',
      },
      {
        label: 'Furniture Removal',
        link: '/furniture-removal',
      },
      {
        label: 'Piano Removal',
        link: '/piano-removal',
      },
      {
        label: 'TV and Electronics Removal',
        link: '/tv-electronics-removal',
      },
      {
        label: 'Yard Debris Removal',
        link: '/yard-debris-removal',
      },
      {
        label: 'Other Junk Removal',
        link: '/junk-removal',
      },
    ],
  },
  {
    label: 'Cardboard Recycling',
    link: '/cardboard-recycling',
    column: 2,
  },
  {
    label: 'Dumpster Rentals',
    link: '/dumpster-rental',
    column: 2,
  },
  {
    label: 'Pallet Disposal',
    link: '/pallet-disposal',
    column: 2,
  },
  {
    label: 'General Waste Disposal',
    link: '/general-waste-disposal',
    column: 2,
  },
  {
    label: 'Certified Destruction',
    link: '/certified-destruction',
    column: 2,
  },
  {
    label: "E-Waste Disposal",
    link: "/ewaste",
    column: 2,
  },
  {
    label: 'Trash Valet',
    link: '/trash-valet',
    column: 2,
  },
  {
    label: 'Solar Panel Services',
    link: '/solar-panel-disposal',
    column: 3,
    subLinks: [
      {
        label: 'Solar Panel Disposal',
        link: '/solar-panel-disposal',
      },
      {
        label: 'Solar Panel Recycling',
        link: '/solar-panel-disposal',
      },
      {
        label: 'Sell Solar Panels',
        link: '/solar-panel-sell',
      },
      {
        label: 'Solar Decommissioning',
        link: '/solar-decommissioning',
      },
    ],
  },
  {
    label: 'Recurring Services',
    link: '/recurring-waste-services',
    column: 3,
    subLinks: [
      {
        label: 'Commercial Waste Disposal',
        link: '/commercial-waste-disposal',
      },
      {
        label: 'Residential Trash and Recycling',
        link: '/residential-trash-and-recycling',
      },
      {
        label: 'Dumpster Swaps',
        link: '/dumpster-swaps',
      },
    ],
  },
  {
    label: 'Property Cleanouts',
    link: '/property-cleanouts',
    column: 3,
    subLinks: [
      {
        label: 'Commercial Office Cleanout',
        link: '/commercial-office-cleanout',
      },
      {
        label: 'Residential Cleanout',
        link: '/residential-cleanout',
      },
    ],
  },
  {
    label: 'Composting Services',
    link: '/commercial-composting',
    column: 3,
    subLinks: [
      {
        // Same href as the parent by design: in the React app both labels
        // rendered a byte-identical page, so the port ships one canonical URL.
        label: 'Commercial Composting',
        link: '/commercial-composting',
      },
      {
        label: 'Commercial Composting in Austin',
        link: '/commercial-composting/austin',
      },
    ],
  },
]

export const businessMenuItems = [
  {
    label: 'Dimension for Business',
    link: '/b2b-solutions',
  },
  {
    label: 'Case Studies',
    link: '/case-studies',
  },
  {
    label: 'Business Solutions',
    link: '/business',
  },
]

export const providersMenuItems = [
  {
    label: 'Become a Provider',
    link: '/provider_portal',
  },
  {
    label: 'Provider Portal',
    link: '/provider_portal',
    id: 'provider_portal_direct',
  },
  {
    label: 'Provider Agreement',
    link: '/provider-agreement',
    isRedirect: true,
  },
  {
    label: 'Service Provider Policy',
    link: '/service-provider-policy',
    isRedirect: true,
  },
]

export const aboutUsMenuItems = [
  {
    label: 'About Dimension',
    link: '/about_us',
  },
  {
    label: 'Dimension vs. Competition',
    link: '/dimension-vs-competition',
  },
  {
    label: 'Careers',
    link: 'https://jobs.lever.co/getdimension',
    isOutsideLink: true,
  },
  {
    label: 'Blog',
    link: '/blog',
  },
  {
    label: 'Company News',
    link: '/in-the-news',
  },
]

export const aboutUsMenuItemsCustomer = [
  {
    label: 'About Dimension',
    link: '/about_us',
  },
  {
    label: 'Dimension vs. Competition',
    link: '/dimension-vs-competition',
  },
  {
    label: 'Blog',
    link: '/blog',
  },
  {
    label: 'Company News',
    link: '/in-the-news',
  },
]

export const sustainabilityItems = [
  {
    label: 'Sustainable Solutions',
    link: '/sustainability',
  },
  {
    label: 'How to Recycle',
    link: '/recycling',
  },
  {
    label: 'Waste Streams',
    link: '/materials',
  },
  {
    label: 'Sanitizer and PPE',
    link: '/hand-sanitizer-disposal',
  },
  {
    label: 'Pallet Disposal',
    link: '/pallet-disposal',
  },
  {
    label: 'Hazardous Waste',
    link: '/hazardous-waste-disposal',
  },
  {
    label: 'Solar Panels',
    link: '/solar-panel-disposal',
  },
]

export const supportMenuItems = [
  {
    label: 'Help Center',
    link: 'https://support.getdimension.com/',
    isOutsideLink: true,
  },
  {
    label: 'Contact us',
    link: '',
    isChatLauncher: true,
  },
]

export const loggedInCustomerSupportMenuItems = [
  {
    label: 'Help Center',
    link: 'https://support.getdimension.com/en_us/categories/customer-faq-SkghOgbbi',
    isOutsideLink: true,
  },
  {
    label: 'Contact us',
    link: '',
    isChatLauncher: true,
  },
  {
    label: 'Terms of Service',
    link: '/terms',
    isRedirect: true,
  },
  {
    label: 'Privacy Policy',
    link: '/privacy-policy',
    isRedirect: true,
  },
]

export const loggedInSupportItems = [
  {
    label: 'Help Center',
    link: 'https://support.getdimension.com/en_us/categories/provider-faq-HkPjq9kZi',
    isOutsideLink: true,
  },
  {
    label: 'Contact us',
    link: '',
    isChatLauncher: true,
  },
  {
    label: 'Service Provider Policy',
    link: '/service-provider-policy',
    isRedirect: true,
  },
  {
    label: 'Provider Agreement',
    link: '/provider-agreement',
    isRedirect: true,
  },
]

export const headerMenu = {
  headerMenu: [
    {
      label: 'Our Services',
      menuItems: ourServicesMenuItems,
      link: null,
    },
    {
      label: 'Business',
      menuItems: businessMenuItems,
      link: null,
    },
    {
      label: 'Providers',
      menuItems: providersMenuItems,
      link: null,
    },
    {
      label: 'Sustainability',
      menuItems: sustainabilityItems,
      link: null,
    },
    {
      label: 'About Us',
      menuItems: aboutUsMenuItems,
      link: null,
    },
    {
      label: 'Support',
      menuItems: supportMenuItems,
      link: null,
    },
  ],
  providerHeaderMenu: [
    {
      label: 'Provider Portal',
      menuItems: [],
      link: '/provider_portal',
    },
    {
      label: 'Support',
      menuItems: loggedInSupportItems,
      link: null,
    },
  ],
  customerHeaderMenu: [
    {
      label: 'Business',
      menuItems: businessMenuItems,
      link: null,
    },
    {
      label: 'Sustainability',
      menuItems: sustainabilityItems,
      link: null,
    },
    {
      label: 'About Us',
      menuItems: aboutUsMenuItemsCustomer,
      link: null,
    },
    {
      label: 'Support',
      menuItems: loggedInSupportItems,
      link: null,
    },
  ],
}

export const accountMenuItems = (profile?: any, isMobile?: boolean) => {
  return {
    providerSideNavLinks: [
      {
        icon: <MdFormatListBulleted color='primary' />,
        label: 'Get Tasks',
        link: '/get_tasks',
        static: false,
        hidden: !isMobile || (!!profile?.approvalState && profile.approvalState !== 'complete'),
      },
      {
        icon: <MdOutlineEventNote color='primary' />,
        label: 'My Tasks',
        link: '/tasks',
        static: false,
        hidden:
          (!!profile?.approvalState && profile.approvalState !== 'complete') || profile?.isBanned,
      },
      {
        icon: <MdFormatListBulleted color='primary' />,
        label: 'Bid On Tasks',
        link: '/get_bids',
        static: false,
        hidden: !isMobile || (!!profile?.approvalState && profile.approvalState !== 'complete'),
      },
      {
        icon: <MdOutlineEventNote color='primary' />,
        label: 'My Bids',
        link: '/bids',
        static: false,
        hidden:
          (!!profile?.approvalState && profile.approvalState !== 'complete') || profile?.isBanned,
      },
      {
        icon: <MdAccountCircle color='primary' />,
        label: 'Account',
        link: '/account',
        static: false,
      },
      {
        icon: <MdNotifications color='primary' />,
        label: 'Alert Settings',
        link: '/alerts',
        static: false,
        hidden: profile?.isBanned,
      },
      {
        icon: <MdOutlineLocalShipping color='primary' />,
        label: 'Vehicle Info',
        link: '/vehicle_info',
        static: false,
        hidden: profile?.isBanned,
      },
    ],
    customerSideNavLinks: [
      {
        icon: <MdBusiness color='primary' />,
        label: 'Edit Company',
        link: '/company',
        static: false,
        isBusiness: true,
        hidden: true,
      },
      {
        icon: <MdOutlineEventNote color='primary' />,
        label: 'My Bookings',
        link: '/bookings',
        static: false,
      },
      {
        icon: <MdAccountCircle color='primary' />,
        label: 'Account',
        link: '/account',
        static: false,
      },
      {
        icon: <MdSettings color='primary' />,
        label: 'SMS and Email settings',
        link: '/alerts_sms_email',
        static: false,
      },
      {
        icon: <MdOutlinePower color='primary' />,
        label: 'Integrations',
        link: '/integrations',
        static: false,
        isIntegrations: true,
        hidden: !profile?.showIntegrations,
      },
      // {
      //   icon: <PermPhoneMsgOutlinedIcon color="primary" />,
      //   label: "Contact us",
      //   link: "/help",
      //   static: false,
      // },
    ],
  }
}

export const mobileAccountItems = [
  {
    label: 'Account',
    link: '/account',
    icon: account,
  },
  {
    label: 'My Bookings',
    link: '/bookings',
    icon: bookings,
  },
  {
    label: 'SMS and Email Settings',
    link: '/alerts_sms_email',
    icon: mail,
  },
]
